/**
 * Created by asiulik on 24.04.2017.
 */

define(['jquery', 'sticky'], function($){

    //@todo check sticky is used

    function Sticky(){}

    Sticky.prototype.init = function(){


        if(this.sticky) this.destroy();
        this.sticky = [];

        this.defaultStickyItems = $('[data-sticky]');

        this.addItems(this.defaultStickyItems);

    };

    Sticky.prototype.addItems = function(items) {

        var _this = this;

        this.defaultStickyItems.stick_in_parent({
            parent: $('.t__content'),
            offset_top: 90
        });

    };

    Sticky.prototype.destroy = function(){

    };

    return Sticky;

});



// WEBPACK FOOTER //
// ./Private/Scripts/core/sticky.js